module.exports = __webpack_public_path__ + "prod-assets/sunchair-772e82.obj";


//////////////////
// WEBPACK FOOTER
// ./assets/sunchair.obj
// module id = 24
// module chunks = 0